"use client";

import Link from "next/link";
import DomeGallery from "./dome-gallery";
import React from "react";

export default function PortfolioHome() {
  const [hasMounted, setHasMounted] = React.useState(false);

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  return (
    <section className="w-full bg-[#FAFAFA] dark:bg-black min-w-[320px] flex items-center justify-center px-4 sm:px-6 md:px-8 lg:px-10">
      {/* Wrapper to control the width of the grid */}
      <div className="relative z-20 w-full max-w-[1100px]">
        {/* Grid container with fixed height classes */}
        <div className="relative z-50 w-full h-full border-l-2 border-r-2 border-[#EAEAEA] dark:border-[#1E1E1E] flex flex-col mx-auto overflow-hidden">
          <div className="mb-6 lg:mb-12 lg:ml-5 ml-4">
            <div className="relative z-20 flex flex-row sm:mr-5 md:mr-10 items-start justify-start">
              <h1 className="lg:text-6xl md:text-5xl text-4xl mt-4 lg:mt-10 mr-2 md:mr-4 lg:mr-5 font-bold">
                Portfolio
              </h1>
              <h4 className="lg:text-4xl md:text-2xl text-xl mt-7 md:mt-8 lg:mt-15 font-bold">
                for my projects
              </h4>
            </div>
            <div className="flex md:gap-6 lg:gap-10 gap-4 mt-3 lg:mt-5 mr-10 items-start justify-start">
              <Link href="/portfolio" className="underline">
                Look at my portfolio
              </Link>
            </div>
          </div>

          <div className="relative flex w-[1500px] md:w-[1850px] h-[800px] md:h-[1000px] items-center justify-center">
            {hasMounted ? (
              <DomeGallery
                grayscale={false}
                fit={0.67}
                minRadius={300}
                maxVerticalRotationDeg={0}
                segments={40}
                dragDampening={5}
              />
            ) : (
              <div className="absolute flex w-[1500px] md:w-[1850px] h-[800px] md:h-[1000px] items-center justify-center">
                <div className="absolute w-full h-[99%] left-8 animate-pulse bg-neutral-200 dark:bg-neutral-800 rounded-[20%/70%] overflow-hidden"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
